import { PhoneFormatter } from 'field-kit';
import { parsePhoneNumber } from 'libphonenumber-js';

// 555-555-5555
const REGULAR = {
  delimiterMap: {
    3: '-',
    7: '-'
  },
  maximumLength: 12
};

// 1 555-555-5555
const COUNTRY_CODE = {
  delimiterMap: {
    1: ' ',
    5: '-',
    9: '-'
  },
  maximumLength: 14
};

// +1 555-555-5555
const COUNTRY_CODE_PLUS = {
  delimiterMap: {
    0: '+',
    2: ' ',
    6: '-',
    10: '-'
  },
  maximumLength: 15
};
export default class USPhoneFormatter extends PhoneFormatter {
  format(text) {
    if (!text || text.length === 0) {
      return super.format(text);
    }
    let startWithOne = false;
    if (text.startsWith('1')) {
      text = `+${text}`;
      startWithOne = true;
    }
    try {
      const phoneNumber = parsePhoneNumber(text, 'US');
      text = phoneNumber.number;
    } catch {
      return text;
    }

    // +1XXXXXXXXXX to 1 XXX-XXX-XXXX
    if (startWithOne) {
      // remove +
      if (text.length > 2) {
        text = text.slice(1);
      }

      // add space between 1 and numbers
      if (text.length > 2) {
        text = `${text.slice(0, 1)} ${text.slice(1)}`;
      }

      // add first dash
      if (text.length > 2) {
        text = `${text.slice(0, 5)}-${text.slice(5)}`;
      }

      // add second dash
      if (text.length > 7) {
        text = `${text.slice(0, 9)}-${text.slice(9)}`;
      }
    } else {
      // number did not begin with 1, don't include it.
      // remove +1
      if (text.length > 2) {
        text = text.slice(2);
      }

      // add first dash
      if (text.length > 2) {
        text = `${text.slice(0, 3)}-${text.slice(3)}`;
      }

      // add second dash
      if (text.length > 6) {
        text = `${text.slice(0, 7)}-${text.slice(7)}`;
      }
    }
    return text;
  }
  guessFormatFromText(text) {
    if (!text) {
      super.guessFormatFromText(text);
      return;
    }
    if (text.startsWith('+')) {
      this.delimiterMap = COUNTRY_CODE_PLUS.delimiterMap;
      this.maximumLength = COUNTRY_CODE_PLUS.maximumLength;
    } else if (text.startsWith('1')) {
      this.delimiterMap = COUNTRY_CODE.delimiterMap;
      this.maximumLength = COUNTRY_CODE.maximumLength;
    } else {
      this.delimiterMap = REGULAR.delimiterMap;
      this.maximumLength = REGULAR.maximumLength;
    }
  }
}